import { Slot } from '@radix-ui/react-slot';
import React from 'react';
import type { TransformedCSSProperties } from '../component.types';
import { transformSpecialCSSProperties } from '../utils';

/**
 * Generic DOM/Element Component
 *
 * Render any element or Component passed `as` prop (default `div`),
 * _or_ use `asChild` to merge with direct child.
 *
 * Applies `transformSpecialCSSProperties` to handle special CSS props
 */
type AsProps<T> = T extends React.ElementType ? React.ComponentProps<T> : {};
export interface ElementProps
  extends React.PropsWithChildren<React.HTMLAttributes<HTMLElement>>,
    TransformedCSSProperties {
  as?: React.ElementType;
  asChild?: boolean;
}

export const Element = React.forwardRef<HTMLElement, ElementProps & AsProps<React.ElementType>>(
  function Element({ as: AsComponent = 'div', asChild = false, ...props }, ref) {
    const finalProps = transformSpecialCSSProperties(props);
    const Component = asChild ? Slot : AsComponent;
    return <Component {...finalProps} ref={ref} />;
  }
);

Element.displayName = 'Element';
